import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications

import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map } from 'rxjs'; // this created errors ats use below

import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UploadDocxTemplateModalComponent} from './../upload-docx-template-modal/upload-docx-template-modal.component';
import {UploadEmailTemplateModalComponent} from './../upload-email-template-modal/upload-email-template-modal.component';

import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';
import {SubjectComTypes} from '../../../shared/models/subjectComTypesModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HotToastService } from '@ngneat/hot-toast';


@Component({
  selector: 'app-subject-com-type-create',
  templateUrl: './subject-com-type-create.component.html',
  styleUrls: ['./subject-com-type-create.component.css']
})
export class SubjectComTypeCreateComponent implements OnInit {
  nav: any;
  doc_id: number;
  model: SubjectComTypes;
  subject_template_doc: Object;


  public baseUploadURL:any;
  @ViewChild('brandForm') form: any; // the name of the form to access.
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  stripped: any;
  filenameselected: any;
  brand_types: any;
  baseUploadURLEmailTemplates: string;
  subject_com_types: Object;
  sent_subject_com_type_id: any;
  subject_com_type_id: number;
  subject_com_type: Object;
  get_latest_subject_com_type_id: Object;

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      public toastr: HotToastService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
  ) { 
    this.nav = document.querySelector('nav.navbar');

    this.subject_com_type_id = +this.route.snapshot.paramMap.get('subject_com_type_id');
  }

  ngOnInit() {
    this.model = new SubjectComTypes();
    this.getBrandTypes();
    this.getSubjectComTypes();
  }


  getSubjectComType(subject_com_type_id) {
    this._demoService.getSubjectComType(subject_com_type_id).subscribe(
      data => { this.subject_com_type = data; },
      err => console.error(err),
      () => console.log('')
    );
  }

// need to change this below
editComType(model){
  // model.job_id = this.job_id;
   this._demoService.updateSubjectComType(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Communication Type Updated');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
  // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
  // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => console.error(err),
    () => console.log('done updates')
);
  }


  createComType(model) {
    this._demoService.createSubjectComType(model).subscribe(
         data => {  this.get_latest_subject_com_type_id = data; // this is the retuned json upon creation.
          this.toastr.success('Communication Type Added');
         // this.router.navigate(['../../companies'], { relativeTo: this.route });
          return true;
         },
         error => {
           this.toastr.error('Adding Failed :: Please try again!');
           // console.log(Observable.throw(error));
           // return Observable.throw(error);
         }
    );
    }




 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }

    private getSubjectComTypes() {
      this._demoService.getSubjectComTypes()
        .subscribe(
          res => this.subject_com_types = res,
          err => console.error(err.status)
        );
    }

    sendSubjectComTypeID(subject_com_type_id) {
      // do nothing
        }



     // to router navigate back
     public goBack() {
      this._location.back();
    }

    docView(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
    }

    docEdit(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
    }





}
